


















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { FilterGroup } from '@/models/reports/filter-group';
import { Filter } from '@/models/reports/filter';
import { FieldSelectorSelection } from '@/models/field-selector/field-selector-selection';
import { Field } from '@/models/reports/report-field';
import ReportFilterGroup from '@/components/reports/report-filter-group.vue';
import FieldSelector from '@/components/field-selector/field-selector.vue';

@Component({
    components: {
        ReportFilterGroup,
        FieldSelector,
    },
})
export default class ReportResultsFiltering extends Vue {
    @Prop({ required: true }) private filterGroups: Array<FilterGroup>;
    @Prop() public selectedEntities!: Array<number | null | undefined>;

    private tempFilterGroups: Array<FilterGroup> = this.filterGroups;
    private hasFilterGroups: boolean = false;

    private selectedFilter: Filter | null = null;
    private showFilterFieldSelector: boolean = false;

    private selectorOptions: FieldSelectorSelection;

    @Watch('filterGroups')
    private filterGroupsChange(filterGroups: Array<FilterGroup>) {
        this.tempFilterGroups = filterGroups;

        this.hasFilterGroups = this.tempFilterGroups.length > 0;
    }

    private addFilterGroup() {
        this.$emit('add-filter-group');
    }

    private removeFilterGroup(id: string) {
        this.$emit('remove-filter-group', id);
    }

    private removeFilter(filterGroup: FilterGroup) {
        this.$emit('remove-filter', filterGroup);
    }

    private addFilter(filterGroup: FilterGroup) {
        this.$emit('add-filter', filterGroup);
    }

    private openFieldSelector(filter: Filter) {
        this.selectedFilter = filter;
        this.showFilterFieldSelector = true;
        const results = new FieldSelectorSelection();

        results.SingleSelect = true;
        results.RestrictToEntityTypes = this.selectedEntities;

        if (filter.field) {
            results.Selections.push(filter.field);
        }

        this.selectorOptions = results;
    }

    private selectField(selections: Array<Field>): void {
        if (selections == null || selections.length === 0 || this.selectedFilter == null) {
            return;
        }

        const filterGroupIndex = this.tempFilterGroups.findIndex((x) => x.id === this.selectedFilter!.filterGroupId);
        if (filterGroupIndex === -1) {
            return;
        }
        const filterGroup = this.tempFilterGroups[filterGroupIndex];
        const filterIndex = filterGroup!.filters.findIndex((x) => x.id === this.selectedFilter!.id);
        if (filterIndex === -1) {
            return;
        }

        const selection = selections[0];
        if (selection == null) {
            return;
        }

        this.selectedFilter.field = selection;
        // TODO(George)- why is this not working? cant find a reason
        if (selection.dataTypeName.indexOf('Date', 0) === 0) {
            this.selectedFilter.operator = '30';
        } else {
            this.selectedFilter.operator = selection.dataTypeName.lastIndexOf('Text', 0) === 0 ? '22' : '2';
        }
        filterGroup!.filters.splice(filterIndex, 1, this.selectedFilter);

        this.$emit('update-filter-groups', this.tempFilterGroups);

        this.selectedFilter = null;
        this.showFilterFieldSelector = false;
    }

    private cancelSelect() {
        this.showFilterFieldSelector = false;
        this.selectedFilter = null;
    }
}
